import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListQueryPaginationPayload } from '@app-store/slices/templates/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.templates.list

// This saga is for getting list of companies
function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = yield getParams(payload)

        const response = yield axios.get(`/notifications/templates`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
        } else {
            if (payload.sagaCB) {
                yield payload.sagaCB?.onFailure(response.result)
            }
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload.sagaCB) {
            yield payload.sagaCB?.onFailure()
        }
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
